import axios from "axios";
import { API_BASE_URL } from "../api/endpoints";

/**
 * Cliente próprio, sem os interceptors do `api/client`. Eles poriam o ID token de quem estiver logado
 * no painel naquele navegador numa rota que não pede token, e o `Authorization` faz o navegador mandar
 * um OPTIONS antes de cada consulta do mapa — o dobro de requisições no Cloud Run.
 */
const publico = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

const rastreioPublicoApi = {
  /* Número, status, origem, destino e pontos do frete do link — GET /v1/rastreio-publico/:token */
  buscarResumo(token) {
    return publico.get(`/v1/rastreio-publico/${encodeURIComponent(token)}`);
  },

  /* Trajeto do mais novo para o mais antigo — GET /v1/rastreio-publico/:token/trajeto */
  buscarTrajeto(token, params) {
    return publico.get(
      `/v1/rastreio-publico/${encodeURIComponent(token)}/trajeto`,
      { params },
    );
  },

  /* O que chegou desde a última consulta — GET /v1/rastreio-publico/:token/trajeto/novidades */
  novidadesDoTrajeto(token, params) {
    return publico.get(
      `/v1/rastreio-publico/${encodeURIComponent(token)}/trajeto/novidades`,
      { params },
    );
  },
};

export default rastreioPublicoApi;
